import { FC } from "react";

import { TFunction, useTranslation } from "next-i18next";

import Image from "@components/Image";
import { useRouter } from "@lib/router";
import { ROUTES } from "@utils/constants";

import { DeliveryMethod, OrderFields } from "../../../constants";
import useOrderData from "../../../context/useOrderData";
import useOrderFormik from "../../../hooks/useOrderFormik";
import OrderInfoItem from "../OrderInfoItem";

const getDeliveryMethodTitle = (t: TFunction, deliveryMethod: DeliveryMethod): string => {
  const titlesMap = {
    [DeliveryMethod.PudoToPudo]: t("order-delivery_method-pudo_pudo"),
    [DeliveryMethod.PudoToDoor]: t("order-delivery_method-pudo_door"),
    [DeliveryMethod.DoorToDoor]: t("order-delivery_method-door_door"),
    [DeliveryMethod.DoorToPudo]: t("order-delivery_method-door_pudo"),
  };
  return titlesMap[deliveryMethod] || "";
};

const OrderInfoPackageSize: FC = () => {
  const { t } = useTranslation();

  const {
    values: { [OrderFields.PACKAGE_SIZE]: packageSizeTitle, [OrderFields.DELIVERY_METHOD]: deliveryMethod },
  } = useOrderFormik();

  const {
    dynamicData: { packageSizes },
  } = useOrderData();

  const router = useRouter();

  const selectedPackageSize = packageSizes.find(({ title }) => title === packageSizeTitle);

  const size = selectedPackageSize?.title;

  const sizeDescription = (
    <>
      {t("order-summary-size", { size })}
      <br />
      {selectedPackageSize?.description}
    </>
  );

  const handleEditClick = () => {
    router.push(ROUTES.ORDER);
  };

  return (
    <OrderInfoItem
      id="order-package-size"
      title={getDeliveryMethodTitle(t, deliveryMethod as DeliveryMethod)}
      description={sizeDescription}
      isFixedWidthTitle
      image={<Image src="/assets/images/package.png" alt="" fill={true} />}
      onEditClick={handleEditClick}
    />
  );
};
export default OrderInfoPackageSize;
